webpackJsonp([1],{

/***/ 10:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["default"] = ({
				data: function data() {
								return {
												env: this.tools.single().isBrowserClient(),
												browser: this.tools.single().riskClient(),
												os: this.tools.single().isOSClient(),
												stateParams: this.tools.single().getStateParams(),
												isRedirect: this.tools.single().getUrlParam('isredirect'),
												backUrl: this.tools.single().getUrlParam('backurl'),
												isClosed: false,
												URL: {
																"ios": {
																				downloadUrl: "https://itunes.apple.com/app/id745097904",
																				urlScheme: "yqbnative://app.1qianbao.com",
																				universalLink: "https://oia.yqb.com/ow"
																},
																"android": {
																				downloadUrl: "//d.1qianbao.com/youqian/app/1qb_88888.apk",
																				urlScheme: "yqbnative://app.1qianbao.com"
																},
																"baseUrl": "//d.1qianbao.com/youqian/",
																"yybUrl": "http://a.app.qq.com/o/simple.jsp?pkgname=com.paic.zhifu.wallet.activity" },
												evokeConfig: {}
								};
				},

				props: ['tools'],
				methods: {
								closePage: function closePage() {
												history.go(-1);
												this.isClosed = true;
								},
								callApp: function callApp(obj) {
												this.stateParams.callType == 'h5' ? this.evokeH5() : this.evokeNative();
								},
								evokeNative: function evokeNative(obj) {
												var defaultOption = {
																module: "huoqianbao",
																action: "index",
																_tpl: "eyJ0cGwiOnsidHBsSWQiOiIxIn0sIm1pblZlcnNpb24iOiIzLjAuMCIsIm1heFZlcnNpb24iOiI5LjkuOSJ9"
												};
												var module = void 0,
												    action = void 0,
												    _tpl = void 0,
												    fromApp = void 0;
												var option = obj && obj.module !== 'undefined' && typeof obj.action !== 'undefined' ? obj : this.stateParams;
												if (typeof option.module !== 'undefined' && typeof option.action !== 'undefined') {
																module = option.module;
																action = option.action;
																_tpl = option._tpl;
																fromApp = option.fromApp;
												} else {
																module = defaultOption.module;
																action = defaultOption.action;
																_tpl = defaultOption._tpl;
																fromApp = defaultOption.fromApp;
												}
												this.evokeConfig = { module: module, action: action, _tpl: _tpl, fromApp: fromApp, callType: 'native' };
												this.evokeUp([module, "/", action].join(""), _tpl, fromApp);
								},
								evokeH5: function evokeH5(obj) {
												var defaultOption = {
																url: 'http://h5.1qianbao.com/yqbBalance/index.html#/balance/myFundsList',
																tokenType: '1',
																contentClass: '',
																caller: '',
																isNativeNav: true };

												var tokenType = void 0,
												    contentClass = void 0,
												    caller = void 0,
												    isNativeNav = void 0,
												    url = void 0,
												    fromApp = void 0;
												var option = obj && obj.url !== 'undefined' && typeof obj.tokenType !== 'undefined' ? obj : this.stateParams;
												if (typeof option.url !== 'undefined' && typeof option.tokenType !== 'undefined') {
																url = option.url;
																tokenType = option.tokenType;
																contentClass = typeof option.contentClass === 'undefined' ? '' : option.contentClass;
																caller = typeof option.caller === 'undefined' ? '' : option.caller;
																isNativeNav = typeof option.isNativeNav === 'undefined' ? true : option.isNativeNav;
																fromApp = option.fromApp;
												} else {
																url = defaultOption.url;
																tokenType = defaultOption.tokenType;
																contentClass = defaultOption.contentClass;
																caller = defaultOption.caller;
																isNativeNav = defaultOption.isNativeNav;
																fromApp = defaultOption.fromApp;
												}
												var config = {
																"minVersion": "5.0.1",
																"maxVersion": "",
																"tpl": {
																				"tplId": "tplId",
																				"tplParams": {
																								tokenType: tokenType,
																								contentClass: contentClass,
																								caller: caller,
																								isNativeNav: isNativeNav,
																								url: obj || typeof this.stateParams.url === 'undefined' ? url : decodeURIComponent(url)
																				}
																}
												};
												this.evokeConfig = { url: encodeURIComponent(url), tokenType: tokenType, contentClass: contentClass, caller: caller, isNativeNav: isNativeNav, fromApp: fromApp, callType: 'h5' };
												this.evokeUp("openUrl/index", this.tools.single().Base64Encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(config), false), fromApp);
								},
								evokeUp: function evokeUp(assembleUrl, _tpl, isFromApp) {
												var JumpUrl = "",
												    DownloadUrl = "";

												if (this.os == 'ios') {
																var iosVersion = this.tools.single().getIOSVersion();
																if (this.tools.single().compareVersion(iosVersion, "9.0")) {
																				if (isFromApp) {
																								JumpUrl = [this.URL.ios.urlScheme, "/", assembleUrl, "?_tpl=", _tpl].join("");
																				} else {
																								JumpUrl = [this.URL.ios.universalLink, "/", assembleUrl, "?_tpl=", _tpl].join("");
																								if (this.isRedirect) {
																												JumpUrl = [JumpUrl, '&isredirect=', this.isRedirect, '&backurl=', this.backUrl].join('');
																								}
																				}

																				window.location.href = JumpUrl;
																} else {
																				JumpUrl = [this.URL.ios.urlScheme, "/", assembleUrl, "?_tpl=", _tpl].join("");

																				this.openApp(JumpUrl, this.isRedirect, function (isOpen) {});
																}
																DownloadUrl = this.URL.ios.downloadUrl;
												} else if (this.os == 'android') {
																JumpUrl = [this.URL.ios.urlScheme, "/", assembleUrl, "?_tpl=", _tpl].join("");
																DownloadUrl = this.URL.android.downloadUrl;

																this.openApp(JumpUrl, this.isRedirect, function (isOpen) {});
												} else {
																window.location.href = this.URL.baseUrl;
												}
								},
								openApp: function openApp(openUrl, isRedirect, callback) {
												var _this = this;

												function checkOpen(cb) {
																var _clickTime = +new Date();

																function check(elsTime) {
																				if (elsTime > 3000 || document.hidden || document.webkitHidden) {
																								cb(1);
																				} else {
																								cb(0);
																				}
																}

																var _count = 0,
																    intHandle;
																intHandle = setInterval(function () {
																				_count++;
																				var elsTime = +new Date() - _clickTime;
																				if (_count >= 100 || elsTime > 3000) {
																								clearInterval(intHandle);
																								check(elsTime);
																				}
																}, 20);
												}

												var ifr = document.createElement('iframe');
												ifr.src = openUrl;
												ifr.style.display = 'none';
												if (callback) {
																checkOpen(function (opened) {
																				callback && callback(opened);
																});
												}
												document.body.appendChild(ifr);
												setTimeout(function () {
																var url = 'https://d.1qianbao.com/activity/h5/evoke/middle.html?';
																var params = [];
																for (var key in _this.evokeConfig) {
																				_this.evokeConfig[key] && params.push(key + '=' + _this.evokeConfig[key]);
																}
																url = url + params.join('&');
																if (_this.isRedirect) {
																				url += '&isredirect=' + _this.isRedirect + '&backurl=' + _this.backUrl;
																}
																window.location.href = url;
												}, 500);
								},
								forDownLoad: function forDownLoad() {
												if (this.os == 'ios') {
																window.location.href = this.URL.ios.downloadUrl;
												} else if (this.os == 'android') {
																if (this.env == 'wechat') {
																				window.location.href = this.URL.yybUrl;
																} else {
																				window.location.href = this.URL.android.downloadUrl;
																}
												} else {
																window.location.href = this.URL.android.baseUrl;
												}
								}
				}
});

/***/ }),

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_tools__ = __webpack_require__(6);





var tools = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_tools__["a" /* default */])();

__webpack_require__(7);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App :tools="tools" />',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a },
  data: function data() {
    return {
      tools: tools
    };
  }
});

/***/ }),

/***/ 29:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrapper"
  }, [(!_vm.isClosed) ? _c('div', {
    staticClass: "popup-wrapper"
  }, [_c('div', {
    staticClass: "popup-dialog"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("打开壹钱包APP")]), _vm._v(" "), _c('div', {
    staticClass: "btn-box"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.closePage
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.callApp
    }
  }, [_c('strong', [_vm._v("确定")])])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 6:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);


var _Single = null;
/* harmony default export */ __webpack_exports__["a"] = (function () {
    return function () {
        function toolInstance() {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, toolInstance);

            if (!_Single) {
                _Single = this;
            }
            return _Single;
        }

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(toolInstance, [{
            key: 'compareVersion',
            value: function compareVersion(version, baseVersion) {
                var versionNumArray = version.split('.');
                var baseVersionNumArray = baseVersion.split('.');
                var versionNum = parseInt(versionNumArray[0] + versionNumArray[1] + (versionNumArray[2] || "0") + (versionNumArray[3] || "0"));
                var baseVertion = parseInt(baseVersionNumArray[0] + baseVersionNumArray[1] + (baseVersionNumArray[2] || "0") + (baseVersionNumArray[3] || "0"));
                if (versionNum >= baseVertion) {
                    return true;
                } else {

                    return false;
                }
            }
        }, {
            key: 'getIOSVersion',
            value: function getIOSVersion() {
                var ua = navigator.userAgent;
                if (ua.toLowerCase().indexOf("like mac os x") > 0) {
                    var regStr_saf = /os [\d._]*/gi;
                    var verinfo = ua.toLowerCase().match(regStr_saf);
                    return (verinfo + "").replace(/[^0-9|_.]/ig, "").replace(/_/ig, ".");
                }
                return false;
            }
        }, {
            key: 'isBrowserClient',
            value: function isBrowserClient() {
                var ua = navigator.userAgent.toLowerCase();
                if (/micromessenger/i.test(ua)) {
                    return 'wechat';
                } else if (/1qianbao/i.test(ua)) {
                    return 'YQB';
                } else if (/mqqbrowser/i.test(ua)) {
                    return 'qq';
                } else if (/weibo/i.test(ua)) {
                    return 'weibo';
                } else {
                    return 'h5';
                }
            }
        }, {
            key: 'isOSClient',
            value: function isOSClient() {
                var ua = navigator.userAgent.toLowerCase();
                if (/android/i.test(ua)) {
                    return 'android';
                } else if (/ipad|ipod|iphone/i.test(ua)) {
                    return 'ios';
                } else {
                    return 'others';
                }
            }
        }, {
            key: 'riskClient',
            value: function riskClient() {
                var ua = navigator.userAgent.toLowerCase();

                if (/micromessenger/i.test(ua)) {
                    return 'wechat';
                } else if (/1qianbao/i.test(ua)) {
                    return 'M-100001';
                } else if (/android/i.test(ua)) {
                    return 'android';
                } else if (/ucbrowser/i.test(ua)) {
                    return 'uc';
                } else if (/mqqbrowser/i.test(ua)) {
                    return 'qq';
                } else if (/weibo/i.test(ua)) {
                    return 'weibo';
                } else if (/firefox/i.test(ua)) {
                    return 'FF';
                } else if (/chrome/i.test(ua)) {
                    return 'chrome';
                } else if (/msie/i.test(ua)) {
                    return 'IE';
                } else if (/safari/i.test(ua)) {
                    return 'safari';
                } else if (/MetaSr/i.test(ua)) {
                    return 'sogo';
                } else {
                    return 'h5';
                }
            }
        }, {
            key: 'Base64Encode',
            value: function Base64Encode(str, needUtf16to8) {
                var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

                function utf16to8(str) {
                    var out = "",
                        i,
                        len = str.length,
                        c;
                    for (i = 0; i < len; i++) {
                        c = str.charCodeAt(i);
                        if (c >= 0x0001 && c <= 0x007F) {
                            out += str.charAt(i);
                        } else if (c > 0x07FF) {
                            out += String.fromCharCode(0xE0 | c >> 12 & 0x0F);
                            out += String.fromCharCode(0x80 | c >> 6 & 0x3F);
                            out += String.fromCharCode(0x80 | c >> 0 & 0x3F);
                        } else {
                            out += String.fromCharCode(0xC0 | c >> 6 & 0x1F);
                            out += String.fromCharCode(0x80 | c >> 0 & 0x3F);
                        }
                    }
                    return out;
                }

                function encode64(input) {
                    var output = "";
                    var chr1,
                        chr2,
                        chr3 = "";
                    var enc1,
                        enc2,
                        enc3,
                        enc4 = "";
                    var i = 0;
                    do {
                        chr1 = input.charCodeAt(i++);
                        chr2 = input.charCodeAt(i++);
                        chr3 = input.charCodeAt(i++);
                        enc1 = chr1 >> 2;
                        enc2 = (chr1 & 3) << 4 | chr2 >> 4;
                        enc3 = (chr2 & 15) << 2 | chr3 >> 6;
                        enc4 = chr3 & 63;
                        if (isNaN(chr2)) {
                            enc3 = enc4 = 64;
                        } else if (isNaN(chr3)) {
                            enc4 = 64;
                        }
                        output = output + keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
                        chr1 = chr2 = chr3 = "";
                        enc1 = enc2 = enc3 = enc4 = "";
                    } while (i < input.length);
                    return output;
                }

                if (needUtf16to8) {
                    return encode64(utf16to8(str));
                } else {
                    return encode64(str);
                }
            }
        }, {
            key: 'getStateParams',
            value: function getStateParams() {
                var pairs = window.location.search.substring(1).split("&"),
                    obj = {},
                    pair,
                    i;
                if (window.location.search !== "") {
                    for (i in pairs) {
                        if (pairs[i] === "") continue;
                        pair = pairs[i].split("=");
                        obj[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
                    }
                }
                return obj;
            }
        }, {
            key: 'getUrlParam',
            value: function getUrlParam(name, url) {
                if (!name) {
                    return '';
                }
                url = url || location.search;
                name = name.replace(/(?=[\\^$*+?.():|{}])/, '\\');
                var reg = new RegExp('(?:[?&]|^)' + name + '=([^?&#]*)', 'i');
                var match = url.match(reg);
                return !match ? '' : match[1];
            }
        }], [{
            key: 'single',
            value: function single() {
                if (!_Single) _Single = new toolInstance();
                return _Single;
            }
        }]);

        return toolInstance;
    }();
});

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(29),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ })

},[11]);


// WEBPACK FOOTER //
// static/js/index.e0f84afddd301387e7b9.js